import { TimePickerLocale } from '../TimePicker';

const locale: TimePickerLocale = {
  placeholder: '请选择时间',
  rangePlaceholder: ['开始时间', '结束时间'],
};

export default locale;
